export const LIST_BRANCH_LIMIT = 20;
export const STATIC_BRANCH_LIMIT = 250;
export const AB_TEST_BRANCH_LIMIT = 100;
export const CLASSIC_DEFAULT_FILTER_BRANCH = [[]];
export const PLATFORM_DEFAULT_FILTER_BRANCH = null;